// import React, { useEffect, useState } from 'react';
// import { Container, Typography, Box, Select, MenuItem, FormControl, InputLabel, Grid, Paper } from '@mui/material';
// import { toast } from 'react-toastify';
// import config from '../config';
// import 'react-toastify/dist/ReactToastify.css';

// const AdminGallery = () => {
//   const [users, setUsers] = useState([]);
//   const [selectedUser, setSelectedUser] = useState('');
//   const [images, setImages] = useState([]);

//   useEffect(() => {
//     const fetchUsers = async () => {
//       const token = localStorage.getItem('adminToken');
//       if (!token) {
//         toast.error('You are not logged in.');
//         return;
//       }

//       try {
//         const response = await fetch(`${config.backendUrl}/api/admin/users`, {
//           headers: {
//             'Authorization': `Bearer ${token}`
//           }
//         });
//         const data = await response.json();
//         if (response.ok) {
//           setUsers(data);
//         } else {
//           toast.error('Failed to load users');
//         }
//       } catch (error) {
//         console.error('Error:', error);
//         toast.error('An error occurred. Please try again.');
//       }
//     };

//     fetchUsers();
//   }, []);

//   const fetchImages = async (userId) => {
//     const token = localStorage.getItem('adminToken');
//     if (!token) {
//       toast.error('You are not logged in.');
//       return;
//     }

//     try {
//         const response = await fetch(`${config.backendUrl}/api/admin/images?userId=${userId}`, {
//           headers: {
//             'Authorization': `Bearer ${token}`
//           }
//         });
//       const data = await response.json();
//       if (response.ok) {
//         setImages(data);
//       } else {
//         toast.error('Failed to load images');
//       }
//     } catch (error) {
//       console.error('Error:', error);
//       toast.error('An error occurred. Please try again.');
//     }
//   };

//   const handleUserChange = (event) => {
//     const userId = event.target.value;
//     setSelectedUser(userId);
//     fetchImages(userId);
//   };

//   return (
//     <Box sx={{ width: '100%', padding: 0 }}>
//       <Container maxWidth={false} sx={{ width: '100%', paddingLeft: 0, paddingRight: 0 }}>
//         <Box sx={{ marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
//           <Typography component="h1" variant="h5" sx={{ width: '30rem', textAlign: 'start' }}>
//             Gallery
//           </Typography>
//           <FormControl fullWidth sx={{ mt: 2, mb: 4, width: '90%' }}>
//             <InputLabel>Select User</InputLabel>
//             <Select
//               value={selectedUser}
//               onChange={handleUserChange}
//               label="Select User"
//             >
//               {users.map((user) => (
//                 <MenuItem key={user.id} value={user.id}>
//                   {user.username}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//           <Box sx={{ width: '100%', maxHeight: '60vh', overflowY: 'auto' }}>
//             <Grid container spacing={2} sx={{ width: '100%', margin: 0 }}>
//               {images.map((image) => (
//                 <Grid item xs={12} sm={6} md={4} key={image.id}>
//                   <Paper sx={{ height: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
//                     <img src={`${config.backendUrl}${image.image_url}`} alt={image.name} style={{ maxWidth: '100%', maxHeight: '100%' }} />
//                   </Paper>
//                 </Grid>
//               ))}
//             </Grid>
//           </Box>
//         </Box>
//       </Container>
//     </Box>
//   );
// };

// export default AdminGallery;





import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import config from '../config';
import 'react-toastify/dist/ReactToastify.css';
import { Container, Typography, Box, TextField, Button } from '@mui/material';

const AddCalendlyLink = () => {
  const [calendlyLink, setCalendlyLink] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      toast.error('You are not logged in.');
      navigate('/admin/login');
    }
  }, [navigate]);

  const handleAddCalendlyLink = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('adminToken');
    if (!token) {
      toast.error('You are not logged in.');
      navigate('/admin/login');
      return;
    }

    try {
      const response = await fetch(`${config.backendUrl}/api/admin/calendly-link`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ calendlyLink }),
      });

      const data = await response.json();
      if (response.ok) {
        toast.success('Calendly link added successfully!');
        setCalendlyLink('');
      } else {
        toast.error(`Error: ${data.message}`);
      }
    } catch (error) {
      toast.error('An error occurred. Please try again.');
    }
  };

  return (
    <Container maxWidth="md">
      <Box sx={{ marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography component="h1" variant="h5">
          Add Calendly Link
        </Typography>
        <Box component="form" onSubmit={handleAddCalendlyLink} sx={{ mt: 3 }}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="calendlyLink"
            label="Calendly Link"
            value={calendlyLink}
            onChange={(e) => setCalendlyLink(e.target.value)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 3, mb: 2 }}
          >
            Save Calendly Link
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default AddCalendlyLink;
